import React from 'react';
import { useLocation } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import './StepNavigation.css';

const steps = [
  { id: 1, label: 'Bank', paths: ['/bank-selection', '/account-dashboard'] },
  { id: 2, label: 'IBAN', paths: ['/iban-verification'] },
  { id: 3, label: 'OTP', paths: ['/otp-verification'] },
  { id: 4, label: 'Amount', paths: ['/payment-details', '/reference-number'] },
  { id: 5, label: 'Receipt', paths: ['/receipt-upload', '/upload-receipt'] },
  { id: 6, label: 'Status', paths: ['/status'] },
];

function StepNavigation() {
  const location = useLocation();
  const currentPath = location.pathname;

  // Don't show on CNIC entry page (root path)
  if (currentPath === '/' || currentPath === '') {
    return null;
  }

  // Find current step based on path
  const getCurrentStep = () => {
    for (const step of steps) {
      if (step.paths.some(path => currentPath.includes(path))) {
        return step.id;
      }
    }
    return 1;
  };

  const currentStep = getCurrentStep();

  return (
    <div className="progress-tracker-wrapper">
      <div className="progress-tracker-horizontal">
        {steps.map((step, index) => {
          const isActive = step.id === currentStep;
          const isCompleted = step.id < currentStep;

          return (
            <React.Fragment key={step.id}>
              <div className={`tracker-step ${isCompleted ? 'completed' : ''} ${isActive ? 'active' : ''}`}>
                <div className="tracker-dot">
                  {isCompleted ? (
                    <CheckCircle size={14} />
                  ) : (
                    <span className="tracker-number">{step.id}</span>
                  )}
                </div>
                <span className="tracker-label">{step.label}</span>
              </div>
              {index < steps.length - 1 && (
                <div className={`tracker-connector ${isCompleted ? 'completed' : ''}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default StepNavigation;
